module.exports = __webpack_public_path__ + "img/tESTIMONIAL 1.ace85764.jpeg";